export const homeCategories = [
  {
    name: "Hotel",
    path: "/hotel",
    image: "https://images.pexels.com/photos/70441/pexels-photo-70441.jpeg",
    subcategories: [
      {
        name: "Restaurants",
        path: "/hotel/restaurants",
        image: "https://images.pexels.com/photos/262047/pexels-photo-262047.jpeg",
        subcategories: [
          {
            name: "Restaurant A",
            path: "/hotel/restaurants/a",
            image: "https://images.pexels.com/photos/260922/pexels-photo-260922.jpeg",
            products: [
              {
                id: "pizza",
                name: "Pizza",
                image: "https://media.istockphoto.com/id/1494273340/photo/pizza-with-pepperoni-arugula-ketchup-tomatoes-and-cheese-in-a-plate-on-a-white-background.jpg?b=1&s=612x612&w=0&k=20&c=kF0TcNtpkCEZQHrQqz9u1r6_HipIM7OUcWc0Vbmw8Rc=",
                rent: false,
                appointment: false,
                withoutQuantity: false,
                type: "menu",
                price: 12,
                companyId: "restaurant-a"
              },
              {
                id: "burger",
                name: "Burger",
                image: "https://media.istockphoto.com/id/1309352410/photo/cheeseburger-with-tomato-and-lettuce-on-wooden-board.jpg?b=1&s=612x612&w=0&k=20&c=qD01FkeyMFSpGVvle2OXoQNYJlbgsDPk2L5_GeHe8RU=",
                rent: false,
                appointment: false,
                withoutQuantity: false,
                type: "menu",
                price: 9,
                companyId: "restaurant-a"
              }
             
            ]
          },
          {
            name: "Restaurant B",
            path: "/hotel/restaurants/b",
            image: "https://media.istockphoto.com/id/1845430946/photo/abstract-blur-defocus-coffee-shop-cafe-or-restaurant-interior-background-blurred-cafe.jpg?b=1&s=612x612&w=0&k=20&c=ljY9SmDwJ2Tka5OXVGd71purn5R_8ZDhiVpiGdkzsV8=",
            products: [
              {
                id: "steak",
                name: "Steak",
                image: "https://media.istockphoto.com/id/594465522/photo/grilling-steaks-on-flaming-grill-and-shot-with-selective-focus.jpg?b=1&s=612x612&w=0&k=20&c=268d7HewWCy8KdUde1VXwlVcV2248LYPQUmOUeJ1vzc=",
                rent: false,
                appointment: false,
                withoutQuantity: false,
                type: "menu",
                price: 20,
                companyId: "restaurant-b"
              },
              {
                id: "salad",
                name: "Salad",
                image: "https://media.istockphoto.com/id/1987499256/photo/salad-in-black-bowl-at-dark-background.jpg?b=1&s=612x612&w=0&k=20&c=X5MIBbtzUnleXEMDR2F_4HlcGbR4qJ4zehlB7otwPWM=",
                rent: false,
                appointment: false,
                withoutQuantity: false,
                type: "menu",
                price: 8,
                companyId: "restaurant-b"
              }
            ]
          }
        ]
      },
      {
        name: "Room Service",
        path: "/hotel/room-service",
        image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSesuuhXqt7yT8gnlh6bSiAmAx1u0z8U_aI1Q&s",
        products: [
          {
            id: "extra-towels",
            name: "Extra Towels",
            image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTzMth7hV4OBcnr3gvoy7i-NSFSDH0FRQvfkQ&s",
            rent: false,
            appointment: false,
            withoutQuantity: true,
            type: "room",
            price: 0,
            companyId: "hotel"
          },
          {
            id: "laundry",
            name: "Laundry",
            image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR1jSFM1JF3TCW6GaG6m--CxLDWpR8Y_oBEIg&s",
            rent: false,
            appointment: false,
            withoutQuantity: true,
            type: "room",
            price: 0,
            companyId: "hotel"
          },
          {
            id: "room-cleaning",
            name: "Room Cleaning",
            image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSxMXPE__5f2tM9dQzsmeWLd127aWunZG5chg&s",
            rent: false,
            appointment: false,
            withoutQuantity: true,
            type: "room",
            price: 0,
            companyId: "hotel"
          }
        ]
      }
    ]
  },
  {
    name: "Cars",
    path: "/cars",
    image: "https://media.istockphoto.com/id/1478431022/photo/cars-for-sale-stock-lot-row.jpg?b=1&s=612x612&w=0&k=20&c=M8M4RHWKzIDba-I2d2MgVwqtD3yCvsMZRwXSRT7OMOk=",
    subcategories: [
      {
        name: "Car Rent",
        path: "/cars/rent",
        image: "https://media.istockphoto.com/id/1478431022/photo/cars-for-sale-stock-lot-row.jpg?b=1&s=612x612&w=0&k=20&c=M8M4RHWKzIDba-I2d2MgVwqtD3yCvsMZRwXSRT7OMOk=",
        products: [
          {
            id: "toyota-corolla",
            name: "Toyota Corolla",
            image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRSPSSJWD-hx0E-GYlBC0TpJXIRKS3hEPUBbA&s",
            rent: true,
            appointment: false,
            withoutQuantity: true,
            type: "rental",
            price: 50,
            companyId: "car-rent"
          },
          {
            id: "honda-civic",
            name: "Honda Civic",
            image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTIxM2qnZxLPuOnX3iesLJfevklK-0Ycmuc0A&s",
            rent: true,
            appointment: false,
            withoutQuantity: true,
            type: "rental",
            price: 55,
            companyId: "car-rent"
          }
        ]
      },
      {
        name: "VIP Car Rent",
        path: "/cars/vip",
        image: "https://images.pexels.com/photos/164634/pexels-photo-164634.jpeg",
        products: [
          {
            id: "mercedes-s",
            name: "Mercedes S-Class",
            image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTz3Ou8Tbe678E6SjWKZ5Kh_UupRmzZPCutpw&s",
            rent: true,
            appointment: false,
            withoutQuantity: true,
            type: "rental",
            price: 200,
            companyId: "vip-rent"
          },
          {
            id: "bmw-7",
            name: "BMW 7 Series",
            image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTYWA0kvSrH5iLVZV1HlgDrjdkB1JrVqDI2IA&s",
            rent: true,
            appointment: false,
            withoutQuantity: true,
            type: "rental",
            price: 180,
            companyId: "vip-rent"
          }
        ]
      },
      {
        name: "Ride",
        path: "/cars/ride",
        image: "https://images.pexels.com/photos/620335/pexels-photo-620335.jpeg",
        products: [
          {
            id: "airport-pickup",
            name: "Airport Pickup",
            image: "https://images.pexels.com/photos/14912365/pexels-photo-14912365.jpeg",
            rent: false,
            appointment: true,
            withoutQuantity: true,
            type: "booking",
            price: 30,
            companyId: "ride-service"
          },
          {
            id: "city-tour",
            name: "City Tour Ride",
            image: "https://images.pexels.com/photos/466685/pexels-photo-466685.jpeg",
            rent: false,
            appointment: true,
            withoutQuantity: true,
            type: "booking",
            price: 40,
            companyId: "ride-service"
          }
        ]
      }
    ]
  },
  {
    name: "Services",
    path: "/services",
    image: "https://images.pexels.com/photos/1416530/pexels-photo-1416530.jpeg",
    subcategories: [
      {
        name: "Salons",
        path: "/services/salons",
        image: "https://images.pexels.com/photos/3993320/pexels-photo-3993320.jpeg",
        products: [
          {
            id: "haircut",
            name: "Haircut",
            image: "https://images.pexels.com/photos/1319458/pexels-photo-1319458.jpeg",
            rent: false,
            appointment: true,
            withoutQuantity: true,
            type: "booking",
            price: 25,
            companyId: "salon"
          },
          {
            id: "shaving",
            name: "Shaving",
            image: "https://images.pexels.com/photos/897262/pexels-photo-897262.jpeg",
            rent: false,
            appointment: true,
            withoutQuantity: true,
            type: "booking",
            price: 15,
            companyId: "salon"
          }
        ]
      },
      {
        name: "Outside Spa",
        path: "/services/spa",
        image: "https://images.pexels.com/photos/1123256/pexels-photo-1123256.jpeg",
        products: [
          {
            id: "full-body-massage",
            name: "Full Body Massage",
            image: "https://images.pexels.com/photos/3230236/pexels-photo-3230236.jpeg",
            rent: false,
            appointment: true,
            withoutQuantity: true,
            type: "booking",
            price: 70,
            companyId: "spa"
          },
          {
            id: "hot-stone",
            name: "Hot Stone Therapy",
            image: "https://images.pexels.com/photos/5378218/pexels-photo-5378218.jpeg",
            rent: false,
            appointment: true,
            withoutQuantity: true,
            type: "booking",
            price: 90,
            companyId: "spa"
          }
        ]
      },
      {
        name: "Bodyguard",
        path: "/services/bodyguard",
        image: "https://media.istockphoto.com/id/1322313658/photo/bodyguards-protecting-businesswoman-opening-car-door.jpg?b=1&s=612x612&w=0&k=20&c=vbt6rWKSUzlDA15XP_9-IjCfliSSkEYE9cxMmcP2jK8=",
        products: [
          {
            id: "personal-security",
            name: "Personal Security",
            image: "https://media.istockphoto.com/id/983222868/photo/bodyguard-opening-car-door-for-businessman.jpg?b=1&s=612x612&w=0&k=20&c=DIOcXH87dw9_TVlspAoqF6ieXYb8_jmCuF4u2tSyk-g=",
            rent: false,
            appointment: true,
            withoutQuantity: false,
            type: "rental",
            price: 300,
            companyId: "bodyguard"
          }
        ]
      },
      {
        name: "Translator",
        path: "/services/translator",
        image: "https://images.pexels.com/photos/267669/pexels-photo-267669.jpeg",
        products: [
          {
            id: "arabic-english",
            name: "Arabic-English",
            image: "https://images.pexels.com/photos/267669/pexels-photo-267669.jpeg",
            rent: false,
            appointment: true,
            withoutQuantity: true,
            type: "rental",
            price: 50,
            companyId: "translator"
          },
          {
            id: "french-english",
            name: "French-English",
            image: "https://images.pexels.com/photos/267669/pexels-photo-267669.jpeg",
            rent: false,
            appointment: true,
            withoutQuantity: true,
            type: "rental",
            price: 50,
            companyId: "translator"
          }
        ]
      },
      {
        name: "Tourist Guide",
        path: "/services/guide",
        image: "https://images.pexels.com/photos/8828439/pexels-photo-8828439.jpeg",
        products: [
          {
            id: "city-tour",
            name: "City Tour",
            image: "https://images.pexels.com/photos/466685/pexels-photo-466685.jpeg",
            rent: false,
            appointment: true,
            withoutQuantity: true,
            type: "booking",
            price: 60,
            companyId: "tourist-guide"
          },
          {
            id: "historical-sites",
            name: "Historical Sites",
            image: "https://media.istockphoto.com/id/539115110/photo/colosseum-in-rome-and-morning-sun-italy.jpg?b=1&s=612x612&w=0&k=20&c=7-Yeouq9PjWzSzsa7ltPh2VGd0BmAzM9pT3e6GKI6nY=",
            rent: false,
            appointment: true,
            withoutQuantity: true,
            type: "booking",
            price: 80,
            companyId: "tourist-guide"
          }
        ]
      }
    ]
  },
  {
    name: "Trips",
    path: "/trips",
    image: "https://images.pexels.com/photos/917510/pexels-photo-917510.jpeg",
    products: [
      {
        id: "desert-safari",
        name: "Desert Safari",
        image: "https://media.istockphoto.com/id/517702606/photo/life-as-opening.jpg?b=1&s=612x612&w=0&k=20&c=_PCTAdPJgk0YVynAtBfCxA2FLmNGRJjmgHHMG3uNJVA=",
        rent: false,
        appointment: true,
        withoutQuantity: true,
        type: "booking",
        price: 150,
        companyId: "trips"
      },
      {
        id: "boat-ride",
        name: "Boat Ride",
        image: "https://media.istockphoto.com/id/1978588900/photo/aerial-view-of-sea-blue-waters-and-coast-of-brighton-east-sussex-uk.jpg?b=1&s=612x612&w=0&k=20&c=yjM2Wq-AX-rBbwgc4ucr7CQJAsnqmP43e_PRReCwe5k=",
        rent: false,
        appointment: true,
        withoutQuantity: true,
        type: "booking",
        price: 120,
        companyId: "trips"
      }
    ]
  },
  {
    name: "Market Place",
    path: "/marketplace",
    image: "https://media.istockphoto.com/id/1160030707/photo/shopping-bags-for-fashion-and-clothing-isolated-on-a-white-background.jpg?b=1&s=612x612&w=0&k=20&c=1yEySToM6pudp_5UunuxjB7hL6EuG1JHHINQj0GcSgk=",
    products: [
      {
        id: "souvenir-a",
        name: "Souvenir A",
        image: "https://media.istockphoto.com/id/946804444/photo/various-souvenir-magnets-from-several-world-country-arranged-on-the-blue-background.jpg?b=1&s=612x612&w=0&k=20&c=oCieFS0aMPU9Jekx-t56OHaOogUZHIIatntxcyVQf2o=",
        rent: false,
        appointment: false,
        withoutQuantity: true,
        type: "menu",
        price: 20,
        companyId: "marketplace"
      },
      {
        id: "souvenir-b",
        name: "Souvenir B",
        image: "https://media.istockphoto.com/id/946804444/photo/various-souvenir-magnets-from-several-world-country-arranged-on-the-blue-background.jpg?b=1&s=612x612&w=0&k=20&c=oCieFS0aMPU9Jekx-t56OHaOogUZHIIatntxcyVQf2o=",
        rent: false,
        appointment: false,
        withoutQuantity: true,
        type: "menu",
        price: 25,
        companyId: "marketplace"
      },
      {
        id: "handmade-craft",
        name: "Handmade Craft",
        image: "https://media.istockphoto.com/id/1490094933/photo/female-sculptor-making-clay-mug-in-a-home-workshop-hands-close-up-small-business.jpg?b=1&s=612x612&w=0&k=20&c=wSBHNK_h9O_X30z3dWMJ7F271rk3paNgjBYxjs4E8Ek=",
        rent: false,
        appointment: false,
        withoutQuantity: true,
        type: "menu",
        price: 35,
        companyId: "marketplace"
      }
    ]
  }
];
